import { createSlice, type PayloadAction } from '@reduxjs/toolkit/react';
import type { UserWithPermissions } from '~/domain/user/types';

type AuthState = {
    isLoggedIn: boolean;
    token: string | null;
    user: UserWithPermissions | null;
};

export const auth = createSlice({
    name: 'auth',
    initialState: {
        isLoggedIn: false,
        token: null,
        user: null,
    } as AuthState,
    reducers: {
        setAuthToken: (state, { payload }: PayloadAction<string | null>) => {
            if (state.token !== payload) {
                state.token = payload;
                state.isLoggedIn = payload !== null;
                state.user = null;
            }
        },
        setUser: (state, { payload }: PayloadAction<UserWithPermissions | null>) => {
            state.user = payload;
        }
    },
    selectors: {
        selectAuthToken: state => state.token,
        selectIsLoggedIn: state => state.isLoggedIn,
        selectUser: state => state.user,
    },
});

export const {
    setAuthToken,
} = auth.actions;

export const {
    selectIsLoggedIn,
    selectUser,
} = auth.selectors;
